export default "__VITE_ASSET__d9328a64__"